<template>
    <div class="big-container">
      <header class="header">
        <img src="https://encaucetotal.com/wp-content/uploads/2021/03/planeta-encauce-300x300.png" alt="Encauce Logo" class="logo" />
        <h1 class="heading">Carrito de Compras</h1>
      </header>
      <div class="container">
        <div class="row">
          <div class="col product-info">
            <h2>Encauce Total</h2>
            <h3 class="price">USD {{ total }}</h3>
            <p class="quantity">Cantidad {{ quantity }}, USD {{ unitPrice }} unidad</p>
          </div>
          <div class="col payment-form">
            <h3>Pago con tarjeta</h3>
            <form @submit.prevent="submitPayment">
              <div class="form-group">
                <label for="email">Correo electrónico</label>
                <input v-model="email" type="email" id="email" required>
              </div>
              <div class="form-group">
                <label for="card-info">Información de la tarjeta</label>
                <div class="card-input-container">
                  <input type="text" class="card-number-input" placeholder="1234 1234 1234 1234" required>
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Visa.svg/1200px-Visa.svg.png" alt="Visa Logo" class="card-logo visa" />
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Mastercard-logo.svg/1200px-Mastercard-logo.svg.png" alt="Mastercard Logo" class="card-logo" />
                </div>
                <div class="card-inputs">
                  <input type="text" placeholder="MM/AA" required>
                  <input type="text" placeholder="CVC" required>
                </div>
              </div>
              <div class="form-group">
                <label for="card-holder-name">Nombre del titular de tarjeta</label>
                <input v-model="cardHolderName" type="text" id="card-holder-name" required>
              </div>
              <div class="form-group">
                <label for="country">País o región</label>
                <select v-model="country" id="country" required>
                  <option>Ecuador</option>
                  <option>México</option>
                </select>
              </div>
              <button type="submit">Pagar</button>
            </form>
          </div>
        </div>
        <footer class="footer">
          <p>Powered by Zwippe</p>
        </footer>
      </div>
    </div>
  </template>
  
  <script>
  import Swal from 'sweetalert2';
  
  export default {
    name: 'StripePayment',
    data() {
      return {
        email: '',
        cardHolderName: '',
        country: 'Ecuador',
        quantity: this.$route.query.quantity || 1,
        total: this.$route.query.total || 0,
        unitPrice: this.$route.query.unitPrice || 0
      };
    },
    methods: {
      async submitPayment() {
        // Mostrar alerta de carga
        Swal.fire({
          title: 'Procesando pago',
          text: 'Por favor, espere...',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading()
          }
        });
        // Simular tiempo de carga de 3 segundos
        await new Promise(resolve => setTimeout(resolve, 3000));
        // Mostrar alerta de completado
        Swal.fire({
          icon: 'success',
          title: 'Pago completado',
          text: '¡El pago se ha realizado con éxito!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          // Redirigir a /register-after-payment
          this.$router.push('/register-after-payment');
        });
      }
    }
  }
  </script>
  
  <style scoped>
  .big-container {
    background: linear-gradient(45deg, #22113d, #2f355e);
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    flex-direction: column;
  }
  
  .container {
    margin-top: 1em;
    max-width: 800px;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .header {
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    margin-top: 1.6em;
  }
  
  .logo {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  
  .heading {
    font-size: 0.9em; /* 20px */
    color: #fff;
    margin: 0;
  }
  
  .row {
    display: flex;
    width: 100%;
  }
  
  .col {
    flex: 1;
    padding: 40px;
  }
  
  .product-info {
    background-color: #f6f9fc;
    border-right: 1px solid #e6e6e6;
    text-align: center;
  }
  
  .product-info h2 {
    font-size: 24px;
    color: #32325d;
  }
  
  .product-info .price {
    font-size: 32px;
    color: #32325d;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  
  .product-info .quantity {
    font-size: 16px;
    color: #6b7c93;
  }
  
  .payment-form {
    padding: 40px;
  }
  
  .payment-form h3 {
    font-size: 20px;
    color: #32325d;
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 20px;
  }
  
  .form-group label {
    display: block;
    font-size: 14px;
    color: #6b7c93;
    margin-bottom: 5px;
  }
  
  .form-group input,
  .form-group select {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    color: #495057;
    border: 1px solid #ced4da;
    border-radius: 4px;
    box-sizing: border-box;
  }
  
  .form-group input::placeholder {
    color: #999;
  }
  
  .card-input-container {
    display: flex;
    align-items: center;
    position: relative;
  }
  
  .card-number-input {
    width: 100%;
    padding-right: 100px;
  }
  
  .visa {
    margin-right: 1.4em;
  }
  
  .card-logo {
    position: absolute;
    right: 10px;
    height: 24px;
    width: auto;
  }
  
  .card-inputs {
    display: flex;
    gap: 10px;
  }
  
  .card-inputs input {
    flex: 1;
  }
  
  button[type="submit"] {
    width: 100%;
    padding: 15px;
    font-size: 16px;
    color: #fff;
    background-color: #6772e5;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  button[type="submit"]:hover {
    background-color: #5469d4;
  }
  
  .footer {
    width: 100%;
    text-align: center;
    padding: 10px 0;
    background-color: #f6f9fc;
    border-top: 1px solid #e6e6e6;
  }
  
  .footer p {
    margin: 0;
    font-size: 14px;
    color: #6b7c93;
  }
  
  .modal {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    text-align: center;
    position: relative;
  }
  
  .modal-content .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 24px;
    cursor: pointer;
  }
  </style>
  